import React, { useEffect, useState } from "react";
import { filters } from "../../../utils/Constant";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  addFilter,
  addFilterList,
  clearFilter,
} from "../../../Redux/slices/eventSlice";
import { getFilterDate } from "../../../utils/helpers";
import { DatePicker } from "antd";
import moment from "moment";
const Filters = () => {
  const { filterList, categories } = useSelector((state) => state.event);
  const dispatch = useDispatch();
  const [newFilterList, setNewFilterList] = useState({});

  const handleDate = (date, formattedDate) => {
    const dateToSend = moment(formattedDate).format("DD MMM YYYY");
    if (date) {
      dispatch(
        addFilter({
          date: dateToSend,
        })
      );
    } else {
      dispatch(addFilter({}));
    }
  };

  useEffect(() => {
    setNewFilterList({
      ...filters,
      Category: categories.map((item) => item.text),
    });
  }, [categories]);

  useEffect(() => {
    setNewFilterList({
      ...filters,
      Category: categories.map((item) => item.text),
    });
  }, [filters]);

  const handleFilter = (type, value) => {
    dispatch(addFilterList({ type, value }));
    let startPrice = "";
    let endPrice = "";
    let category = "";
    let date = "";
    switch (type) {
      case "Category":
        category = value;
        break;
      case "Price":
        if (value[0] === "F") {
          startPrice = "Free";
          endPrice = null;
        } else if (value[0] === "A") {
          startPrice = 2000;
          endPrice = 50000;
        } else if (value[0] === 0) {
          startPrice = 0;
          endPrice = 500;
        } else {
          startPrice = 500;
          endPrice = 2000;
        }

        break;
      case "Date":
        if (value === "Today") {
          date = getFilterDate("Today");
        } else date = getFilterDate("Tomorrow");
        break;

      default:
        break;
    }
    dispatch(
      addFilter({
        startPrice,
        endPrice,
        category,
        date,
      })
    );
  };
  const handleClearFilter = (filterType) => dispatch(clearFilter(filterType));

  return (
    <div className="filters">
      <h1>Filters</h1>
      <div className="filters-container">
        {Object.keys(newFilterList).map((item) => {
          return (
            <div key={`Filter-${item}`} className="filter-container">
              <div className="filter-type flex">
                <p>{item}</p>
                <p
                  className="clear cursor"
                  onClick={() => handleClearFilter(item)}
                  onKeyDown={() => handleClearFilter(item)}
                >
                  Clear
                </p>
              </div>
              <div className="fliter-list">
                {newFilterList[item].map((ele) => {
                  return (
                    <p
                      key={`Filter-${ele}`}
                      className={`filter cursor border-radius-8 ${
                        filterList[item] === ele && "filter-active"
                      }`}
                      onClick={() => handleFilter(item, ele)}
                      onKeyDown={() => handleFilter(item, ele)}
                    >
                      {ele}
                    </p>
                  );
                })}
              </div>
              {item === "Date" && (
                <>
                  <div className="date-check-container">
                    {/* <Checkbox onChange={toggleChecked} />{" "} */}
                    <p className="date">Choose date</p>
                  </div>
                  <DatePicker onChange={handleDate} />
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Filters;
